import { __rest } from "tslib";
import * as React from 'react';
import Button from '@mui/material/Button';
import cn from 'classnames';
import { useTheme } from '../../../../theme';
import { CdnIcon } from '@shared/ui';
const CloseButton = (_a) => {
    var { classes, variant = 'closePopup', disableElevation = true } = _a, restProps = __rest(_a, ["classes", "variant", "disableElevation"]);
    const { CloseButton: theme } = useTheme('BaseComponents');
    return (React.createElement(Button, Object.assign({ variant: "contained", classes: Object.assign(Object.assign({}, classes), { root: cn(theme[variant], classes === null || classes === void 0 ? void 0 : classes.root) }), disableElevation: disableElevation }, restProps),
        React.createElement(CdnIcon, { className: theme.closeIcon, icon: "Action/Close-Clear" })));
};
export default CloseButton;
